
import React, { Component } from 'react';

import WizardModifierDialogue from './Wizard/WizardModifierDialogue';
import ColumnModifierDialogue from './Column/ColumnModifierDialogue';

var displaySettingsUtils = require('../../../../utils/domain/settings/displaySettingsUtils');
var snoozeUtil = require('../../../../utils/domain/snoozeUtil');

class ModifierDialogue extends Component
{

    render()
    {
        if (displaySettingsUtils.getModifierLayout() == "LayoutWithWizard")
        {
            return <WizardModifierDialogue 
                        saleItem = {this.props.saleItem}
                        startingModifierIndex = {this.props.startingModifierIndex}            
                        modifiersViewModels={this.props.modifiersViewModels}
                        isNewOrderFlow={this.props.isNewOrderFlow}
                        hideCancelButton={false}
                        sale ={this.props.sale}
                        menu = {this.props.menu}
                        onSave={this.props.onSave} 
                        onCancel={this.props.onCancel}/>
        }

        return <ColumnModifierDialogue 
                        saleItem = {this.props.saleItem}
                        startingModifierIndex = {this.props.startingModifierIndex}
                        modifiersViewModels={this.props.modifiersViewModels}
                        isNewOrderFlow={this.props.isNewOrderFlow}
                        sale ={this.props.sale}
                        menu = {this.props.menu}
                        onSave={this.props.onSave} 
                        onCancel={this.props.onCancel}/>
    }
}

export default ModifierDialogue;